import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { TokenEntity } from '../../domain/entities/TokenEntity'
export class TokenModel extends TokenEntity {
  constructor(dataDto: TokenEntity) {
    super()
    mapEntityProperties<TokenModel>(this, dataDto)
  }
}
